import { useMutation, useQueryClient } from '@tanstack/react-query';
import { confirmEmailVerification } from '../../api';

export function useConfirmEmailVerification() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ token }: { token: string }) => confirmEmailVerification(token),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['me'] }),
  });
}
